import { Box, Divider } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkLoggedUser } from '../../../redux/usersRedux';
import ReportPZ04ListForm from '../../common/ReportPZ04ListForm/ReportPZ04ListForm';
const ReportPZ04List = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const start = async () => {
      await dispatch(checkLoggedUser());
    };
    start();
  }, [dispatch]);

  return (
    <Box>
      <h1 style={{ fontStyle: 'italic' }}>{t('pz04.register')}</h1>
      <Divider sx={{ width: '100%', mb: 5, mt: 5, bgcolor: '#C09A53' }} />
      <ReportPZ04ListForm />
    </Box>
  );
};

export default ReportPZ04List;
